export const isLocalPatientFile = (file) => file instanceof File;

export const getPatientFileKey = (file, index) => file?.url || index;

export const buildPatientFilesFormData = (patientId, taggedFiles) => {
	const formData = new FormData();

	formData.append('patient_id', String(patientId));

	const localTaggedFiles = taggedFiles.filter(({ file }) => isLocalPatientFile(file));

	formData.append('files_info', JSON.stringify(localTaggedFiles.map(({ fileType }) => ({ file_type: fileType }))));

	localTaggedFiles.forEach(({ file }) => {
		formData.append('files', file);
	});

	return formData;
};

export const getAttendanceFiles = ({ insuranceCardFile, otherDocumentFile, patientFiles = [] }) => {
	return {
		insuranceCardFileId: insuranceCardFile?.id,
		filesIds: [...patientFiles.map((file) => file?.id), otherDocumentFile?.id].filter(Boolean)
	};
};
